import { selectSelectedBuildingProduct } from "../../../../selectors/selectExistingBuildingInfo";
import { selectSelectedBuildingNonCollectibleProduct } from "../../../../selectors/selectRecipeInfo";
export var checkCanCollectProduct = function (path) { return function (building, state$, deps) {
    var state = state$.value;
    var buildingProducts = selectSelectedBuildingProduct(state);
    if (buildingProducts != undefined) {
        var nonCollectibleProduct = selectSelectedBuildingNonCollectibleProduct(state, buildingProducts);
        if (nonCollectibleProduct != undefined) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkCanCollectProduct.ts
// module id = 2050
// module chunks = 3